import { DataTypes } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";

// Grid/table-only field (not part of the equipment form).
export const noiseIndBA: FieldSchema = {
  name: "noiseIndBA",
  // Read-only / additional-info field: fetched & displayed, but excluded from
  // create/update mutations (managed outside the schema equipment form).
  dataTransform: { toGraphql: undefined },
  data: { type: DataTypes.NUMBER },
  grid: {
    displayed: true,
    order: 59,
    label: "Noise in dBA",
    filter: GridFilterTypes.NUMBER,
    integerOnly: true,
  },
};
